import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroAgentes'
})
export class FiltroAgentesPipe implements PipeTransform {

  transform(arreglo: any[], texto: string, columna: string): any[] {
    //console.log(arreglo)

    if(texto ===''){
      return arreglo;
    }

    texto = texto.toLocaleLowerCase();

    return arreglo.filter (item=>{
      return item[columna].toLocaleLowerCase()
      .includes(texto);
    });
    return arreglo;
  }

}
